import { defaultFilter } from 'cmdk'

import { COMMAND_PALETTE_MIN_MATCH_SCORE } from '@/config/constants'

/** cmdk value prefix shared by every org row, so "org" lists them all. */
export const ORG_VALUE_PREFIX = 'org:'

function rawScore(value: string, search: string, keywords?: string[]): number {
  if (!value.startsWith(ORG_VALUE_PREFIX)) {
    return defaultFilter(value, search, keywords)
  }
  // The default filter joins `value` and every keyword into one string and
  // does a subsequence match across it, so letters can come from different
  // fields: `org:community-bridges Community Bridges` satisfies "duty" with the
  // d from "bridges" and u-t-y from "Community". For an org row, Enter reloads
  // the app into another tenant, so it matches only when the prefix, the slug
  // or the name matches on its own. Even the prefix is scored apart: left on
  // the slug, its r would let "runs" match `org:community-bridges`.
  const slug = value.slice(ORG_VALUE_PREFIX.length)
  return Math.max(
    defaultFilter(ORG_VALUE_PREFIX, search),
    defaultFilter(slug, search),
    ...(keywords ?? []).map((keyword) => defaultFilter(keyword, search))
  )
}

/**
 * The palette's cmdk filter: the default fuzzy score, with org rows scored a
 * field at a time and near-misses dropped (see
 * `COMMAND_PALETTE_MIN_MATCH_SCORE`).
 */
export function paletteFilter(
  value: string,
  search: string,
  keywords?: string[]
): number {
  const score = rawScore(value, search, keywords)
  return score >= COMMAND_PALETTE_MIN_MATCH_SCORE ? score : 0
}
